const GRANT_TYPE_CODE = 'authorization_code';
const GRANT_TYPE_REFRESH_TOKEN = 'refresh_token';

const getFormBody = (_payload) => {
    const _formBody = [];
    Object.keys(_payload).forEach((key) => {
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(_payload[key]);
        _formBody.push(`${encodedKey}=${encodedValue}`);
    });
    const formBody = _formBody.join('&');
    return formBody;
};

const fireAPI = async (url, method, body, headers) => {
    const reponse = await fetch(url, {
        method,
        body,
        headers,
    });

    if (reponse.status === 200) {
        const data = await reponse.json();
        return data;
    }
    throw new Error();
};

export const getAccessToken = async (code, authTokenUrl, PAYLOAD) => {
    const url = `${authTokenUrl}`;
    const _payload = {
        ...PAYLOAD,
        grant_type: GRANT_TYPE_CODE,
        code,
    };
    const formBody = getFormBody(_payload);
    const data = await fireAPI(url, 'POST', formBody, {
        'Content-Type': 'application/x-www-form-urlencoded',
    });
    return data;
};

export const getUserInfo = async (accessToken, userInfoUrl) => {
    const url = `${userInfoUrl}`;
    const data = await fireAPI(url, 'POST', null, {
        Authorization: `Bearer ${accessToken}`,
    });
    return data;
};

export const getRefreshToken = async (
    refreshToken,
    authTokenUrl,
    PAYLOAD,
) => {
    const url = `${authTokenUrl}`;
    const _payload = {
        ...PAYLOAD,
        grant_type: GRANT_TYPE_REFRESH_TOKEN,
        refresh_token: refreshToken,
    };
    const formBody = getFormBody(_payload);
    const data = await fireAPI(url, 'POST', formBody, {
        'Content-Type': 'application/x-www-form-urlencoded',
    });
    return data;
};

export const initiateJwtExpiryCounter = (
    refreshToken,
    expiresIn,
    setAuthTokens,
    authTokenUrl,
    PAYLOAD,
) => {
    const offset = 120;
    const delay = expiresIn - offset;

    setTimeout(async () => {
        const data = await getRefreshToken(
            refreshToken,
            authTokenUrl,
            PAYLOAD,
        );
        setAuthTokens({
            ...data,
            isRefresh: true,
        });
    }, delay * 1000);
};

export const redirect = (url) => {
    window.location.replace(url);
};
